/**
 * Sticky CTA Scroll Behavior for How It Works Page
 * Only activates on page.how-it-works template
 */

(function() {
  'use strict';

  // Check if we're on the How It Works page
  const mainContent = document.querySelector('#MainContent');
  if (!mainContent || !(mainContent instanceof HTMLElement)) {
    return;
  }
  
  if (mainContent.dataset.template !== 'page.how-it-works') {
    return;
  }

  const stickyCTAElement = document.querySelector('[data-sticky-cta]');
  if (!stickyCTAElement || !(stickyCTAElement instanceof HTMLElement)) {
    return;
  }

  let hasScrolled = false;
  let ticking = false;

  function updateStickyCTA() {
    if (!stickyCTAElement) return;
    
    const scrollY = window.scrollY || window.pageYOffset;
    
    // Show CTA after user starts scrolling (even 1px)
    if (scrollY > 0) {
      if (!hasScrolled) {
        hasScrolled = true;
      }
      stickyCTAElement.classList.add('is-visible');
    } else {
      stickyCTAElement.classList.remove('is-visible');
      hasScrolled = false;
    }
    
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(updateStickyCTA);
      ticking = true;
    }
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', function() {
    // Check initial scroll position
    updateStickyCTA();
    
    // Listen for scroll events
    window.addEventListener('scroll', onScroll, { passive: true });
  });
})();
